import { Component, OnInit, Input } from '@angular/core';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { Observable, fromEvent, interval, Subject } from 'rxjs';
import { debounce, filter, takeUntil, map } from 'rxjs/operators';

import { SharedSidebarService } from './shared-sidebar.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-shared-sidebar',
    templateUrl: './shared-sidebar.component.html',
    styleUrls: ['./shared-sidebar.component.scss'],
})
export class SharedSidebarComponent implements OnInit {
    @Input() departmentType: any;
    @Input() title: string = 'Menu';
    //prettier-ignore
    isCollapsed = (window.innerWidth < 992);
    icon = window.innerWidth < 992 ? faCaretUp : faCaretDown;

    activeRoute: string;
    destroySubscription$: Subject<any> = new Subject();

    @Input() menu: any;

    constructor(private sharedSidebarService: SharedSidebarService, private router: Router) {}

    ngOnInit(): void {
        this.watchActiveRoute();

        this.activeRoute = this.router.url;
    }

    watchActiveRoute() {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.destroySubscription$)
            )
            .subscribe((event: NavigationEnd) => {
                this.activeRoute = event.url;
                //console.log(this.activeRoute);
            });
    }

    toggleMenu() {
        this.isCollapsed = !this.isCollapsed;
        const nextIcon = this.icon.iconName === 'caret-up' ? faCaretDown : faCaretUp;
        this.icon = nextIcon;
    }

    onLinkClick() {
        this.toggleMenu();
    }

    /**
     * debouncedResizeListener - adiciona escuta de resize da tela
     * com debounce
     * @return {Observable}
     */
    debouncedResizeListener(): Observable<any> {
        return fromEvent(window, 'resize').pipe(debounce(() => interval(1500)));
    }

    /**
     * toggleMenuBasedOnScreenSize - muda comportamento do hero
     * de acordo com tamanho da tela
     * @return void
     */
    toggleMenuBasedOnScreenSize() {
        this.debouncedResizeListener().subscribe(() => {
            //prettier-ignore
            this.isCollapsed = (window.innerWidth < 992);
        });
    }

    /**
     * verifyActiveRoute
     * Retorna se rota ativa é igual a url vinda da api
     * @param sidebarItemRoute {string} - rota ativa
     * @returns {boolean} true|false
     */
    verifyActiveRoute(sidebarItemRoute: string): Boolean {
        const [_, parentRoute] = sidebarItemRoute.split('/');
        // para o departamento institucional precisamos comparar
        // se a rota ativa é exatamente igual a rota da api para evitar um bug (demonstrado abaixo):
        //
        // se a rota for /attachment/25 e utilizarmos .includes com a string /attachment/2
        // para verificar a rota está ativa, a função vai retornar true
        // e teremos dois items com a classe active no frontend
        if (parentRoute === 'institutional') return this.activeRoute === sidebarItemRoute;

        // utlizamos includes para que os submenus dos outros departamentos
        // assim garantimos o item ativo mesmo quando estiver nas subrotas.
        // ex: /youth/ranking, /youth/home
        return this.activeRoute.includes(sidebarItemRoute);
    }

    ngOnDestroy() {
        this.destroySubscription$.next();
    }
}
